import { Component, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-warranty-reminder-config',
  templateUrl: './warranty-reminder-config.component.html',
  styleUrls: ['./warranty-reminder-config.component.css']
})
export class WarrantyReminderConfigComponent implements OnInit, OnChanges, OnDestroy {
  @Input() parentForm: FormGroup;
  @Input() showOverrideCheckbox: boolean = false;
  @Input() isOverride: boolean = false;
  @Input() disableOverride: boolean = true;
  @Output() isOverrideChange = new EventEmitter<boolean>();
  
  public uniqueId: string = Math.random().toString(36).substring(2, 9);
  private overrideSub: Subscription;

  constructor() { }

  ngOnInit() {
    this.updateControlsState();
    // Subscribe to is_override_reminder changes
    if (this.parentForm && this.parentForm.controls.is_override_reminder) {
      this.overrideSub = this.parentForm.controls.is_override_reminder.valueChanges.subscribe(val => {
        this.isOverride = val;
        this.isOverrideChange.emit(val);
        this.updateControlsState();
      });
    }
  }

  updateControlsState() {
    if (!this.parentForm) return;
    if (this.showOverrideCheckbox && !this.isOverride) {
      this.parentForm.controls.is_maintenance_reminder.disable();
      this.parentForm.controls.maintenance_mode.disable();
      this.parentForm.controls.maintenance_cycle.disable();
      this.parentForm.controls.maintenance_cycle_unit.disable();
      this.parentForm.controls.is_extend_maintenance.disable();
      if (this.parentForm.controls.extend_limit) {
        this.parentForm.controls.extend_limit.disable();
      }
      this.parentForm.controls.is_expired_reminder.disable();
      this.parentForm.controls.expired_mode.disable();
      this.parentForm.controls.expired_cycle.disable();
      this.parentForm.controls.expired_cycle_unit.disable();
    } else {
      this.parentForm.controls.is_maintenance_reminder.enable();
      this.parentForm.controls.maintenance_mode.enable();
      this.parentForm.controls.maintenance_cycle.enable();
      this.parentForm.controls.maintenance_cycle_unit.enable();
      this.parentForm.controls.is_extend_maintenance.enable();
      if (this.parentForm.controls.extend_limit) {
        this.parentForm.controls.extend_limit.enable();
      }
      this.parentForm.controls.is_expired_reminder.enable();
      this.parentForm.controls.expired_mode.enable();
      this.parentForm.controls.expired_cycle.enable();
      this.parentForm.controls.expired_cycle_unit.enable();
    }
  }

  ngOnChanges() {
    this.updateControlsState();
  }

  ngOnDestroy() {
    if (this.overrideSub) {
      this.overrideSub.unsubscribe();
    }
  }

  preventNonPositiveNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    // Cho phép: phím số (0–9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return;
    }
    const target = event.target as HTMLInputElement;
    // Ngăn nhập số 0 ở đầu tiên
    if ((target.selectionStart === 0 && target.selectionEnd === target.value.length && charCode === 48) || 
        (target.value === '' && charCode === 48)) {
      event.preventDefault();
    }
  }

  onPastePositiveNumber(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    if (!/^[1-9][0-9]*$/.test(pastedText)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/components/warranty-reminder/warranty-reminder-config/warranty-reminder-config.component.ts